import { render } from "./Editor.vue?vue&type=template&id=7744cf8c&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=7744cf8c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7744cf8c"

export default script